const triggerResendRecoveryFactor= (country, lang, sessionId, emailId) => {
    const headersResendRecovery = new Headers();
    const countryUpperCase = country.toUpperCase();
    const uniqueId = `web-` + generateUniqueID();
    headersResendRecovery.append("x-wu-operationname", "resendRecoveryFactor");
    headersResendRecovery.append("Content-Type", "application/json");
    headersResendRecovery.append("x-wu-accesscode", "RtYV3XDz9EA");
    headersResendRecovery.append("wucountrycode", countryUpperCase);
    headersResendRecovery.append("wulanguagecode", lang);
    headersResendRecovery.append("x-wu-externalRefId", uniqueId);
    headersResendRecovery.append("x-wu-correlationId", uniqueId);
    headersResendRecovery.append("x-wu-session-version", `3`);
    headersResendRecovery.append("version", `V2`);
    headersResendRecovery.append("x-wu-sessionId", sessionId);
    headersResendRecovery.append("x-wu-apiKey", `1978`);
    headersResendRecovery.append("flowname", `REGISTRATION`);
    headersResendRecovery.append("isrrenabled", true);
    headersResendRecovery.append("passwordRecovery", true);
    headersResendRecovery.append("x-wu-retailSessionId", "");
    headersResendRecovery.append("accept-language", `${lang}-${countryUpperCase}`);
  
    let resendRecoveryFactorInput = {
        "email": emailId
    };

    const graphql = JSON.stringify({
      query: window.queryData.resendRecoveryFactoryQuery,
      variables: {
        args_ResendRecoveryFactorInput: resendRecoveryFactorInput,
      },
    });
    const requestOptions = {
      method: "POST",
      headers: headersResendRecovery,
      body: graphql,
      redirect: "follow",
    };
  
    return fetchApiWu(routerUrl, requestOptions,"resendRecoveryFactor");
  };
  
window.queryData.triggerResendRecoveryFactor = triggerResendRecoveryFactor;